import {Component, DoCheck, Input, OnInit} from '@angular/core';
import {PATTERNS} from '../../../common/constants';
import {LookupService} from '../../../common/service/lookup.service';
import {PlanModelService} from '../../../common/service/plan-model.service';
import {FormerTenureValidity} from '../../../common/models/former-tenure-validity.model';
import {NewLotDetails} from '../../../common/models/new-lot-details-model';
import {JsonPipe, NgClass} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NlrHasPermissionsPipe} from '../../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../../common/pipe/nlr-permissions-disabled-pipe';
import {NlrPatternDirective} from '../../../common/directive/nlr-pattern.directive';
import {NlrFormFieldHasErrorPipe} from '../../../common/pipe/nlr-form-field-has-error.pipe';

@Component({
    selector: 'nlr-tenure-new-lot-detail',
    imports: [FormsModule, NgClass, NlrHasPermissionsPipe, NlrPermissionsDisabledPipe, NlrPatternDirective, NlrFormFieldHasErrorPipe, JsonPipe],
    templateUrl: './tenure-new-lot-detail.component.html',
    styleUrl: './tenure-new-lot-detail.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class TenureNewLotDetailComponent implements OnInit, DoCheck {
    @Input() name: string;
    @Input() newLotDetails: NewLotDetails;
    @Input() submitted: boolean;

    disabled = false;

    lotPattern = PATTERNS.LOT_PATTERN;

    fullySupersededByRoadOptions = [
        {name: 'Yes', value: true},
        {name: 'No', value: false}
    ];

    formerTenureValidityLookups: FormerTenureValidity[];

    previousFullySupersededByRoad: boolean;

    constructor(
        private lookupService: LookupService,
        private planModelService: PlanModelService
    ) {}

    ngOnInit(): void {
        this.formerTenureValidityLookups = this.lookupService.getLookups('formerTenureValidity');
        if (!this.newLotDetails.newLotRanges) {
            this.newLotDetails.newLotRanges = [];
        }

        if (this.newLotDetails.newLotRanges.length === 0) {
            this.newLotDetails.newLotRanges.push(this.newLotRange());
        }

        if (!this.newLotDetails.fullySupersededByRoad) {
            this.newLotDetails.fullySupersededByRoad = false;
        }
    }

    ngDoCheck() {
        if (this.newLotDetails.fullySupersededByRoad !== this.previousFullySupersededByRoad) {
            this.previousFullySupersededByRoad = this.newLotDetails.fullySupersededByRoad;
            if (this.newLotDetails.fullySupersededByRoad) {
                this.newLotDetails.newLotRanges.length = 0;
            }
        }
        if (!this.newLotDetails.fullySupersededByRoad) {
            if (!this.newLotDetails.newLotRanges) {
                this.newLotDetails.newLotRanges = [];
            }

            if (this.newLotDetails.newLotRanges.length === 0) {
                this.newLotDetails.newLotRanges.push(this.newLotRange());
            }
        }
    }

    addLotRange(idx: number) {
        this.newLotDetails.newLotRanges.splice(idx + 1, 0, this.newLotRange());
    }

    removeLotRange(idx: number) {
        this.newLotDetails.newLotRanges.splice(idx, 1);
        if (this.newLotDetails.newLotRanges.length === 0) {
            this.newLotDetails.newLotRanges.push(this.newLotRange());
        }
    }

    isRoadWideningShow() {
        const {name, planType, tenureType} = this.planModelService.getModel().planPurpose;
        return this.formerTenureValidityLookups.some(
            v => v.supersededByRdwdgQuestion === true && tenureType === v.tenureType && planType === v.planType && name === v.planPurpose
        );
    }

    newLotRange() {
        return {
            value: ''
        };
    }
}
